<template>
  <div class="note col-12">
    <div class="card no-shadow">
      <div class="card-header">
        <h4 class="mb-0">
          {{ quoteNote.subject }}
        </h4>
      </div>
      <div class="card-body">
        <i
          @click="delQuoteNote()"
          class="fa fa-trash float-right text-danger fa-lg interactive-cursor">
        </i>
        <i
          @click="editQuoteNote()"
          class="fa fa-edit float-right text-primary fa-lg interactive-cursor">
        </i>
        <span class="text-muted">
          {{ quoteNote.createdAt | date_time_format }} - {{ quoteNote.Author.fullName }}
        </span>
        <hr/>
        <p class="mt-3 mb-0">
          {{ quoteNote.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    EDIT_QUOTE_NOTE,
    DELETE_QUOTE_NOTE
  } from '@/vuex/types'
  export default {
    name: 'QuoteNote',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    computed: {
      quoteNote () {
        return {
          Author: {},
          ...this.object
        }
      }
    },
    methods: {
      async delQuoteNote () {
        await this.$store.dispatch(DELETE_QUOTE_NOTE, this.quoteNote.uuid)
      },
      async editQuoteNote () {
        await this.$store.dispatch(EDIT_QUOTE_NOTE, this.quoteNote.uuid)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/displays/QuoteNote.vue